import { __decorate } from 'tslib';
import { Injectable, NgModule } from '@angular/core';
import { ConfigOauthService, ApiService, UiBsOauthModule } from '@wlp/ui-bs-oauth';

let ConfigService = class ConfigService extends ConfigOauthService {
};
ConfigService = __decorate([
    Injectable()
], ConfigService);

const SPE_VIEW_N_WALLET = '/spe-view-n-wallet';
let SpeViewNWalletProxy = class SpeViewNWalletProxy {
    constructor(api) {
        this.api = api;
    }
    getCards(uuidWhiteLabel, uuidAccount) {
        const uri = `${SPE_VIEW_N_WALLET}/v1/cards/white-label/${uuidWhiteLabel}/of-account/${uuidAccount}`;
        return this.api.post(uri);
    }
    getCardsStatus(uuidAccount) {
        const uri = `${SPE_VIEW_N_WALLET}/v1/cards/of-account/${uuidAccount}`;
        return this.api.post(uri);
    }
    cardExtract(uuidWhiteLabel, uuidAccount, card, initialDate, finalDate) {
        const uri = `${SPE_VIEW_N_WALLET}/v1/card/extract/white-label/${uuidWhiteLabel}/account-payment/${uuidAccount}/period/?initialDate=${initialDate}&finalDate=${finalDate}`;
        return this.api.post(uri, card);
    }
    checkRequisitionInProgress(uuidAccountPayment, document) {
        const uri = `${SPE_VIEW_N_WALLET}/v1/cards/requisition-in-progress/account-payment/${uuidAccountPayment}/document/${document}`;
        return this.api.get(uri);
    }
    consultVirtualCard(data, uuidWhiteLabel, uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_WALLET}/v1/cards/white-label/${uuidWhiteLabel}/of-account/${uuidAccountPayment}/virtual-card`;
        return this.api.post(uri, data);
    }
};
SpeViewNWalletProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNWalletProxy = __decorate([
    Injectable()
], SpeViewNWalletProxy);

const SPE_N_WALLET = '/spe-n-wallet';
let SpeNWalletProxy = class SpeNWalletProxy {
    constructor(api) {
        this.api = api;
    }
    requestCard(uuidWhiteLabel, uuidAccount, authentication) {
        const uri = `${SPE_N_WALLET}/v1/card/request/white-label/${uuidWhiteLabel}/account-payment/${uuidAccount}/authentication`;
        return this.api.post(uri, authentication);
    }
    activeCard(uuidWhiteLabel, uuidAccount, card) {
        const uri = `${SPE_N_WALLET}/v1/cards/activate/white-label/${uuidWhiteLabel}/account-payment/${uuidAccount}/card`;
        return this.api.post(uri, card);
    }
    activeCardNoName(uuidWhiteLabel, cardNoName) {
        const uri = `${SPE_N_WALLET}/v1/activate/cards-no-name/white-label/${uuidWhiteLabel}/card`;
        return this.api.post(uri, cardNoName);
    }
    cancelCard(uuidWhiteLabel, uuidAccount, card) {
        const uri = `${SPE_N_WALLET}/v1/cards/cancel/white-label/${uuidWhiteLabel}/account-payment/${uuidAccount}/card`;
        return this.api.post(uri, card);
    }
    blockCard(uuidWhiteLabel, uuidAccount, card) {
        const uri = `${SPE_N_WALLET}/v1/cards/block/white-label/${uuidWhiteLabel}/account-payment/${uuidAccount}/card`;
        return this.api.post(uri, card);
    }
    unlockCard(uuidWhiteLabel, uuidAccount, card) {
        const uri = `${SPE_N_WALLET}/v1/cards/unlock/white-label/${uuidWhiteLabel}/account-payment/${uuidAccount}/card`;
        return this.api.post(uri, card);
    }
    changePassword(uuidWhiteLabel, uuidAccount, pass) {
        const uri = `${SPE_N_WALLET}/v1/cards/change-pass/white-label/${uuidWhiteLabel}/account-payment/${uuidAccount}/pass/card`;
        return this.api.post(uri, pass);
    }
    confirmDocument(uuidAccount, document) {
        const uri = `${SPE_N_WALLET}/v1/card/confirm-document/${uuidAccount}/document/${document}`;
        return this.api.get(uri);
    }
    createWallet(uuidWhiteLabel, uuidAccountPayment, card) {
        const uri = `${SPE_N_WALLET}/v1/wallet/?uuidWhiteLabel=${uuidWhiteLabel}&uuidAccountPayment=${uuidAccountPayment}`;
        return this.api.post(uri, card);
    }
    requestVirtualCard(uuidWhiteLabel, uuidAccountPayment, data) {
        const uri = `${SPE_N_WALLET}/v1/cards/request/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/virtual-card`;
        return this.api.post(uri, data);
    }
    showPassword(uuidWhiteLabel, uuidAccountPayment, body) {
        const uri = `${SPE_N_WALLET}/v1/cards/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/card/password`;
        return this.api.post(uri, body);
    }
};
SpeNWalletProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeNWalletProxy = __decorate([
    Injectable()
], SpeNWalletProxy);

const SPE_J_CHECK_EVENT = '/spe-j-check-event';
let SpeJCheckEventProxy = class SpeJCheckEventProxy {
    constructor(api) {
        this.api = api;
    }
    /**
     * @description Valida se a operação está autorizada
     * @param checkEventBody
     */
    validateOperation(checkEventBody) {
        const uri = `${SPE_J_CHECK_EVENT}/api/check-event/`;
        return this.api.post(uri, checkEventBody);
    }
};
SpeJCheckEventProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeJCheckEventProxy = __decorate([
    Injectable()
], SpeJCheckEventProxy);

const SPE_VIEW_N_ACCOUNT = '/spe-view-n-account';
let SpeViewNAccountProxy = class SpeViewNAccountProxy {
    constructor(api) {
        this.api = api;
    }
    getCardTax(uuidWhiteLabel, uuidAccountPayment, codeOperation) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/taxes-tariff/white-label/${uuidWhiteLabel}/account-payment/${uuidAccountPayment}/code-operation/${codeOperation}`;
        return this.api.get(uri);
    }
    getAccountDataReduceWithAddress(uuidAccountPayment) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/account-data/account-payment-with-address/${uuidAccountPayment}`;
        return this.api.get(uri);
    }
    getCardIssuer(uuidWhiteLabel) {
        const uri = `${SPE_VIEW_N_ACCOUNT}/v1/whiteLabel/${uuidWhiteLabel}/card-issuer`;
        return this.api.get(uri);
    }
};
SpeViewNAccountProxy.ctorParameters = () => [
    { type: ApiService }
];
SpeViewNAccountProxy = __decorate([
    Injectable()
], SpeViewNAccountProxy);

let UiPxCardsModule = class UiPxCardsModule {
};
UiPxCardsModule = __decorate([
    NgModule({
        declarations: [],
        imports: [
            UiBsOauthModule
        ],
        providers: [
            ConfigService,
            SpeNWalletProxy,
            SpeViewNWalletProxy,
            SpeJCheckEventProxy,
            SpeViewNAccountProxy
        ]
    })
], UiPxCardsModule);

class AccountPaymentPersonDto {
}

class CardConsultResultDto {
}

var BlockedEnum;
(function (BlockedEnum) {
    BlockedEnum["UNLOCKED"] = "UNLOCKED";
    BlockedEnum["BLOCKN1"] = "BLOCK N1";
    BlockedEnum["BLOCKN2"] = "BLOCK N2";
    BlockedEnum["BLOCKN3"] = "BLOCK N3";
})(BlockedEnum || (BlockedEnum = {}));

var DeletedEnum;
(function (DeletedEnum) {
    DeletedEnum["FALSE"] = "FALSE";
    DeletedEnum["TRUE"] = "TRUE";
})(DeletedEnum || (DeletedEnum = {}));

/*
 * Public API Surface of ui-px-cards
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AccountPaymentPersonDto, BlockedEnum, CardConsultResultDto, ConfigService, DeletedEnum, SpeJCheckEventProxy, SpeNWalletProxy, SpeViewNAccountProxy, SpeViewNWalletProxy, UiPxCardsModule };
//# sourceMappingURL=wlp-ui-px-cards.js.map
